(ns frontend.test.allocations
  (:require [frontend.routing :as routing]
            [basic-components.inputs.footprint :refer [editor viewer]]
            [basic-components.field-editor :as field-editor]
            [reagent.core :as r]))

(defmethod routing/render-view :test/allocations [{:keys [route-params]}]
  (let [state (r/atom {})]
    [:div.container.bg-white.scroll
     [:h1.title-h1.mb-4 "Allocation split"]
     [:h2.title-h2.mt-4 "Allocation split"]
     [:span "Allocation Splits. Prior to setting up allocations, the codes and names of any sub-allocations (also known as “Allocation Splits”)"]


     [:h3.title-h3.mt-4 "Allocation split input edit mode"]
     [:spand.d-block.mt-2.mb-3 "Allocation split input takes the input as string and number in percentage. Can +Add more rows"]
     [field-editor/view
      {:editor/type         :editor.type/allocation-split
       :value               (:value @state)
       :state-atom          state
       :attribute           :test-allocations-attribute
       :label               "Allocation split"
       :field/tooltip-right "Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
       :on-save!            (fn [new-value]
                              (swap! state assoc :value new-value))
       :show-tooltip-right? true
       :class-name          ""
       :mandatory?          false
       :drag-options        nil
       :validate!           (fn [])
       :disabled?           false
       :read-only?          false
       :error-text          "Test error text"
       :tools               [:tool-item/cancel
                             :tool-item/save
                             :tool-item/edit
                             :tool-item/copy
                             :tool-item/clear]

       :secondary-view-args nil}]

     [:h3.title-h3.mt-4 "Allocation split input read mode"]
     [:span.mt-2 "Allocation split string and number in percentage, can edit, copy and delete entire table"]
     [viewer {:editor/type :editor.type/allocation-split
              :value       [["Some text" 100.0]]}]]))
